import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors'
import { PatientDemographicsConstants } from '../../patientDemographics/store/patientDemographics.constants'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'
import { getCityNemsisCode, ILocationNemsisLookupData, ILocationInfo } from './getCityNemsisCode.saga'
import { getLocationSearchState } from '../selectors'
import { ILocationSearchState } from '../store/locationSearch.types'
import { savePatientDemographics, setCity } from '../../patientDemographics/store/patientDemographics.actions'
import { LocationSearchConstants } from '../store/locationSearch.constants'
import { setErrorInfo } from '../store/locationSearch.actions'
import Logger from '../../../services/logger.service'
import { ICity } from '../../../common/common.types'
import { areObjectsEqual } from '../../../utilities/object.util'

export function* setPatientCityNemsisCode() {
  const { errorMsgsMap }: ILocationSearchState = yield select(getLocationSearchState)
  const { city, state, county }: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const locationInfo: ILocationInfo = { city, state, county }
  try {
    if (city) {
      const nemsisData: ILocationNemsisLookupData = yield call(getCityNemsisCode, locationInfo)
      const updatedCity: ICity = { ...city, nemsisCode: nemsisData.city?.nemsisCode || '' }
      errorMsgsMap[PatientDemographicsConstants.SET_CITY] = nemsisData.cityError
      errorMsgsMap[PatientDemographicsConstants.SET_STATE] = nemsisData.stateError
      errorMsgsMap[PatientDemographicsConstants.SET_COUNTY] = nemsisData.countyError
      if (areObjectsEqual(city, updatedCity)) {
        return
      }
      yield put(setCity(updatedCity))
      yield put(setErrorInfo(errorMsgsMap))
      yield put(savePatientDemographics())
    }
  } catch (e) {
    Logger.error(`Error setPatientCityNemsisCode', ${e}`)
  }
}

export function* setPatientCityNemsisCodeSaga() {
  yield takeLatest(
    [
      LocationSearchConstants.GET_PATIENT_CITY_NEMSIS_CODE,
      PatientDemographicsConstants.SET_PATIENT_DEMOGRAPHICS,
      PatientDemographicsConstants.SET_COUNTY,
      PatientDemographicsConstants.SET_STATE,
    ],
    setPatientCityNemsisCode
  )
}
